module.exports = __webpack_public_path__ + "img/9788992053358.de8a434b.jpg";